import { Checkbox, ListItemText } from '@mui/material';
import { ReactElement } from 'react';
import { getLabel, SelectItemType } from './Option';

export interface DefaultItemRenderProps {
  value: SelectItemType;
  selected?: boolean;
}

export function DefaultItemRender({
  value,
  selected,
}: Readonly<DefaultItemRenderProps>): ReactElement<DefaultItemRenderProps> {
  return (
    <>
      {selected !== undefined && <Checkbox color="primary" checked={selected} />}
      <ListItemText primary={getLabel(value)} />
    </>
  );
}
